
import { defineComponent, PropType, toRaw } from 'vue'

// components
import TheButton from '@/common/components/UI/TheButton/index.vue'

// types
import { GatewayRoleT } from '@/core/types/gateway.types'

export default defineComponent({
    components: {
        'the-button': TheButton,
    },
    props: {
        item: {
            type: Object as PropType<GatewayRoleT>,
            default: null,
        },
    },
    emits: ['update', 'delete', 'open-permissions'],
    setup(props, { emit }) {
        const emitUpdate = () => {
            emit('update', toRaw(props.item))
        }

        const emitDelete = () => {
            emit('delete', toRaw(props.item))
        }

        const emitOpenPermissions = () => {
            emit('open-permissions', toRaw(props.item))
        }

        return { emitUpdate, emitDelete, emitOpenPermissions }
    },
})
